import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDkcAIVAZscS9cAKmR4nR8bxIEm0yvM4iM",
    authDomain: "mytitaniht.firebaseapp.com",
    projectId: "mytitaniht",
    storageBucket: "mytitaniht.appspot.com",
    messagingSenderId: "61662656939",
    appId: "1:61662656939:web:a3e628d48be913f8bdbaee",
    measurementId: "G-VR3S3T2MDQ"
  });

  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const storage = firebase.storage();

  export { db, auth, storage };